<div class="flex flex-column gap-2 mb-4">
  <label for="label">
    <ng-container i18n="@@prompt_node_editor_node_name_label">Nom du noeud</ng-container>
  </label>
  <input
    [ngClass]="{ 'ng-invalid': label === '' }"
    [(ngModel)]="label"
    id="label"
    pInputText
  />
</div>

<div class="flex gap-2 justify-content-end">
  <button
    class="p-button-primary"
    (click)="savePrompt()"
    [disabled]="!label"
    pButton
    type="button"
  >
    {{ dynamicButtonLabel }}
  </button>
  <button
    class="p-button-warning"
    (click)="ref.close()"
    pButton
    type="button"
  >
    <ng-container i18n="@@prompt_node_editor_cancel_button_label">Annuler</ng-container>
  </button>
</div>
